import React from 'react'

import {SaveButton, SaveInput, SaveControlsWrapper, SaveFilterErrorWrapper} from './SaveFilterDialog.styles'

import Typestack from '../../../typestack'
import { Icon } from '../../../../shared/tr-icons'

const SaveFilterErrorDialogComponent = ({events, i18n, saveFilterError}) => {
  return (
    <div>
      <SaveFilterErrorWrapper>
        <Icon type='exclamation' coloured={true} size={60} />
      </SaveFilterErrorWrapper>
      <SaveFilterErrorWrapper>
        <Typestack type='heading' size='md' weight='regular'>{saveFilterError.statusText}</Typestack>
      </SaveFilterErrorWrapper>
      <SaveFilterErrorWrapper>
        <Typestack type='heading' size='xs' weight='regular'>{i18n.saveFilterErrorMsg}</Typestack>
      </SaveFilterErrorWrapper>
      <SaveControlsWrapper>
        <SaveButton href='/' onClick={events.handleCloseClick}>{i18n.saveFilterCloseBtnText}</SaveButton>
      </SaveControlsWrapper>
    </div>
  )
}

export default SaveFilterErrorDialogComponent
